import {useMutation} from "@tanstack/react-query";
import {useModal} from "../../../../../hooks";
import {AxiosError} from "axios";
import {createRevenueByCompany} from "../../../../../api/main/SalesApi";
import {SalesRevenueByCompanyCreateMapType} from "../../list/interface";
import useGoToNavigation from "../../../../../util/useGotoNavigation";


export const useCreateRevenueByCompany = () => {
    const {handleModal} = useModal();
    const {goToNavigation} = useGoToNavigation();

    const {mutate, mutateAsync} = useMutation({
        mutationFn: (data: SalesRevenueByCompanyCreateMapType) => createRevenueByCompany(data),
        onSuccess: (res) => {
            console.log(res)

            if (res.data.code === "0000") {
                handleModal({
                    isOpen: true,
                    contents: "저장되었습니다",
                    type: "alert",
                    closeAction: () => goToNavigation("main/sales/list", {}, false)
                });
            } else if (res.data.code === "E000014") {
                if (res.data.msg.includes("revenue_unique")) {
                    handleModal({
                        isOpen: true,
                        contents: "거래처가 중복되었습니다.",
                        type: "alert",
                    });
                } else {
                    handleModal({
                        isOpen: true,
                        contents: "입력하지 않은 항목이 있습니다.",
                        type: "alert",
                    });
                }
            }
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate, mutateAsync};
};
